// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Jq-z","slideIn":"Kq-z"};